import { ArrowDownIcon, ArrowUpIcon } from '@/components/icons'
import { AreaType } from '@/types/areaZone'
import {
  Collapse,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import { useState } from 'react'
import classes from './styles.module.scss'

interface IProps {
  row: AreaType
}

const AreasAndZonesTableRow = (props: IProps) => {
  const { row } = props

  const [isExpanded, setIsExpanded] = useState(true)

  const toggle = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <>
      <TableRow>
        <TableCell scope="row" className={classes.stackCell}>
          <Stack
            direction="row"
            alignItems="center"
            sx={
              Number(row.level) === 1
                ? {}
                : Number(row.level) === 2
                ? { paddingLeft: '50px', paddingRight: 0 }
                : { paddingLeft: '0px' }
            }
          >
            <Stack sx={{ paddingRight: '20px' }}>
              {Number(row.level) !== 2 ? (
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={toggle}
                >
                  {isExpanded ? (
                    <ArrowDownIcon sx={{ color: 'text.main' }} />
                  ) : (
                    Number(row.parentId) === 0 && (
                      <ArrowUpIcon sx={{ color: 'text.main' }} />
                    )
                  )}
                </IconButton>
              ) : (
                <Stack sx={{ width: '26px' }}></Stack>
              )}
            </Stack>
            <Stack>{row.name}</Stack>
          </Stack>
        </TableCell>
      </TableRow>
      {(row.subAreas || []).length > 0 && (
        <TableRow>
          <TableCell style={{ padding: 0, width: '100%' }} colSpan={10}>
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <Table aria-label="simple table">
                <TableHead
                  sx={{
                    fontWeight: 600,
                    height: 0,
                  }}
                >
                  <TableRow>
                    <TableCell
                      sx={{
                        width: '30%',
                        margin: 0,
                        padding: 0,
                        border: '0 none',
                        height: 0,
                      }}
                    ></TableCell>

                    <TableCell
                      sx={{
                        width: '70%',
                        margin: 0,
                        padding: 0,
                        border: '0 none',
                        height: 0,
                      }}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(row.subAreas || []).map((r) => (
                    <AreasAndZonesTableRow row={r} key={r.id} />
                  ))}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  )
}

export default AreasAndZonesTableRow
